export const prod = true;
export const url = '//api3.app.wakaifu.com';
// export const url = 'http://coat0914.heigu.com';
// export const url = '//h5.api3.wakaifu.com';